import { createAPI } from '@common'
export default {
  // 读分类（分组）树
  getAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'GET', config),
  // 添加分类（分组）
  postAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'POST', config),
  // 修改分类（分组）
  putAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'PUT', config),
  // 删除分类（分组）
  deleteAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'DELETE', config),
  // 删除分类（分组）
  deleteRRCats: config => createAPI('customEncryptApiName-1/0w20ss0dbut', 'DELETE', config),
  // 移动分类（分组）
  postTenantMove: config => createAPI('customEncryptApiName-1/0w20ss0ufobou0npwf', 'POST', config)
}
